// 课后拓展 变更数据
import * as TYPES from './type';

export default{
  [TYPES.WORK_LIST](states,result){
    states.workList = result;
  },
  [TYPES.DEL_WORK](states,result){
    states.delWork = result;
  },
  [TYPES.DEL_WORK_LIST](states,result){
    states.delWorkList = result;
  },
  [TYPES.EDIT_WORK](states,result){
    states.editWork = result;
  },
  [TYPES.ADD_WORK](states,result){
    states.addWork = result;
  },
  [TYPES.GET_WORK_ID](states,result){
    states.getWorkId = result;
  },
  [TYPES.GET_WORK_FJ](states,result){
    states.getWorkFj = result;
  },
  [TYPES.POST_WORK](states,result){
    states.postWork = result;
  },
  [TYPES.GET_WOEK_TOPIC](states,result){
    states.workTopic = result;
  },
  [TYPES.GET_NOT_SUBMIT](states,result){
    states.notSumbitList = result;
  },
  [TYPES.GET_NOT_SUBMIT_TOTAL](states,result){
    states.notSumbitListTotal = result;
  },
  [TYPES.GET_ID_SCORING](states,result){
    states.getIdScoring = result;
  },
  [TYPES.GET_ID_SCORING_FJ](states,result){
    states.getIdScoringFj = result;
  },
  [TYPES.EDIT_ID_SCORING](states,result){
    states.editIdScoring = result;
  },
  [TYPES.EDIT_EDIT_SCORING](states,result){
    states.editEditScoring = result;
  },
  [TYPES.BATCH_TOTAL](states,result){
    states.batchTotal = result;
  },
  [TYPES.BATCH_REJECT](states,result){
    states.batchReject = result;
  },
  [TYPES.EXPORT_EXCEL](states,result){
    states.exportExcel = result;
  },
  [TYPES.REMIND_STUDENT](states,result){
    states.remindStudent = result;
  },
  [TYPES.SET_HOMEWORK_INFO](states, {result, type}){
    states.workinfo[type] = result;
  }
}